export const initialValues = ({
  addMany,
  trappingZone,
  initialTrappingZone
}) => {
  return !addMany
    ? {
        // react-select values
        sprayProduct: '',
        // Regular inputs
        trapping_zone_id: trappingZone.id,
        applied_date: '',
        coverage_days: 7,
        comments: '',
        biofix: false
      }
    : {
        // react-select values
        sprayProduct: '',
        // Regular inputs
        trapping_zones: initialTrappingZone
          ? [
              {
                label: initialTrappingZone.name,
                value: initialTrappingZone.id
              }
            ]
          : [],
        applied_date: '',
        coverage_days: 7,
        comments: '',
        biofix: false
      };
};

export const submitForm = ({
  addMany,
  values,
  actions,
  traplogStore,
  propertiesStore
}) => {
  const url = !addMany
    ? `${process.env.REACT_APP_TRAPLOG_API_URL}api/trapping-zone-spray`
    : `${process.env.REACT_APP_TRAPLOG_API_URL}api/trapping-zone-sprays`;
  const body = !addMany
    ? {
        spray_product_id: values.sprayProduct.value,
        trapping_zone_id: values.trapping_zone_id,
        applied_date: values.applied_date,
        coverage_days: values.coverage_days,
        comments: values.comments,
        biofix: values.biofix
      }
    : values.trapping_zones.map((tz) => ({
        trapping_zone_id: tz,
        spray_product_id: values.sprayProduct.value,
        applied_date: values.applied_date,
        coverage_days: values.coverage_days,
        comments: values.comments,
        biofix: values.biofix
      }));
  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${traplogStore.bearerToken}`,
      SeasonalDatabase: traplogStore.selectedDatabase
    },
    body: JSON.stringify(body)
  })
    .then((res) => {
      if (res.ok) return res.json();
      else if (res.status === 401) traplogStore.refreshBearerToken();
      else throw Error(res.statusText);
    })
    .then(() => {
      traplogStore.loadTrappingZones(
        traplogStore.bearerToken,
        traplogStore.refreshBearerToken,
        traplogStore.selectedDatabase,
        propertiesStore.selectedPropertyId
      );
    })
    .catch((err) => {
      if (process.env.NODE_ENV === 'development') console.error(err);
    })
    .finally(() => {
      actions.setSubmitting(false);
    });
};
